import React, { FC } from 'react';
import { useTranslate } from 'react-admin';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { JsonInput } from './JsonInput';

interface BeneficiaryFormProps {
  keyName: string;
}

const CardIssuingForm: FC<BeneficiaryFormProps> = ({ keyName }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  const td = (key: string): string => translate(`utils.${key}`);
  return (
    <>
      <JsonInput
        label={t('cardIssuingSchema')}
        source={`${keyName}.cardsConfiguration`}
        className={classes.schemaInput}
        validationError={t('jsonError')}
        validationEmptyError={td('jsonEmptyArrayObjectError')}
        initialValue='[]'
        defaultValue='[]'
      />
    </>
  );
};

export default CardIssuingForm;
